import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hover-menu',
  templateUrl: './hover-menu.component.html',
  styleUrls: ['./hover-menu.component.scss']
})
export class HoverMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
